import { FloatingLoader } from "@/components";
import useCases from "@/hooks/useCases";
import type { Case } from "@/types";
import { createFileRoute } from "@tanstack/react-router";
import CaseCard from "../-components/CaseCard";
import EmptyCase from "../-components/Empty";

export const Route = createFileRoute("/dashboard/case/records/closed")({
	component: RouteComponent,
});

function RouteComponent() {
	const navigate = Route.useNavigate();
	const {
		scrollRef,
		caseItems,
		isEmpty,
		isEmptySearch,
		searchQ,
		casesVirtualizer,
		casesVirtualizerItems,
		isLoading,
		isFetchingNextPage,
	} = useCases();

	return (
		<div ref={scrollRef} className="relative h-full w-full overflow-y-auto">
			<FloatingLoader open={isLoading || isFetchingNextPage} />
			<div
				className="relative w-full"
				style={{
					height: casesVirtualizer.getTotalSize(),
				}}
			>
				{casesVirtualizerItems.map((casesVirtualizerItem) => {
					const caseItem = caseItems[casesVirtualizerItem.index];
					if (!caseItem) return null;
					return (
						// biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
						<div
							key={casesVirtualizerItem.key}
							// biome-ignore lint/a11y/useSemanticElements: <explanation>
							role="link"
							tabIndex={0}
							data-index={casesVirtualizerItem.index}
							ref={casesVirtualizer.measureElement}
							className="container absolute top-0 left-0 cursor-pointer"
							style={{
								transform: `translateY(${casesVirtualizerItem.start}px)`,
							}}
							onClick={() =>
								navigate({
									to: "/dashboard/case/view/$id",
									params: { id: caseItem.id },
								})
							}
						>
							<CaseCard
								type="item"
								caseItem={caseItem as Case}
								showLastMessage={false}
							/>
						</div>
					);
				})}
			</div>
			{isEmpty ? <EmptyCase type="list" title="No cases added yet" /> : null}
			{isEmptySearch ? (
				<EmptyCase type="list" title={`No results found for '${searchQ}'`} />
			) : null}
		</div>
	);
}
